// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"5b372643","476":"18f0dc47"}[chunkId] + ".chunk.css";
};